import React from 'react'
import TechnologiesIntro from '../layouts/Technologie/TechnologiesIntro'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import MobileTechStack from '../layouts/Technologie/MobileTechStack'

import TechnologiesSection from '../layouts/Home/TechnologiesSection'
import FinalCTA from '../layouts/FinalCTA'

const Technologie = () => {
    return (
        <>
            <Header />
            <TechnologiesIntro />
            <TechnologiesSection />
            <MobileTechStack />
            <FinalCTA />
            <Footer />
        </>
    )
}

export default Technologie